import useAccount from "./useAccount";

export function useChinaUser() {
  const { data: accountData, isPending: isAccountPending } = useAccount();

  const isLoading = isAccountPending || accountData === undefined;
  const isChinaUser =
    accountData?.countryCode === "CN" || accountData?.flags?.paddleBillingEnabled === true;

  return {
    isChinaUser: isLoading ? undefined : isChinaUser,
    isLoading,
  };
}
